import { render, staticRenderFns } from "./Base_Type3.vue?vue&type=template&id=7238197a&scoped=true"
import script from "./Base_Type3.vue?vue&type=script&lang=js"
export * from "./Base_Type3.vue?vue&type=script&lang=js"
import style0 from "./Base_Type3.vue?vue&type=style&index=0&id=7238197a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238197a",
  null
  
)

export default component.exports